import type { ValuationOverview as ValuationOverviewSchema } from '@einwert/valuation-api-client'

import { styled, useTheme } from '@mui/material'
import { ListCardInfo, MonetaryValue, TrendIcon, Typography } from 'ComponentLibrary'
import { useCurrentResolvedLocale } from 'ClientPortal/src/i18n/currentLocale'

export const ValueInfoCell = ({ valuation }: { valuation: ValuationOverviewSchema }) => {
    const theme = useTheme()
    const locale = useCurrentResolvedLocale()
    const marketValue = MonetaryValue.fromMonetaryValueDataObject(valuation.market_value.value)
    const marketValueTrend = valuation.market_value.trend

    return (
        <ListCardInfo alignItems="flex-end" spacing={theme.spacing(2)} style={{ width: '160px', paddingRight: '10px', flexShrink: 0 }}>
            <BlackTypography variant="bodyTextMedium">{marketValue.format({ withoutDecimals: true, locale })}</BlackTypography>
            {marketValueTrend !== undefined && <TrendIcon variant="label" trend={marketValueTrend} locale={locale} />}
        </ListCardInfo>
    )
}

const BlackTypography = styled(Typography)(({ theme }) => ({
    color: theme.palette.customtext.black100,
    fontWeight: 500,
}))
